import React from 'react';
import { Form, Select, Radio, Input } from 'antd';

import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import globalFormItemLayout from 'components/Portal/formItemLayout'; 
const formItemLayout = Object.assign({}, globalFormItemLayout, {labelCol: {sm: {span: 8}}, wrapperCol: {sm: {span: 16}}});

const gradeLevels = [
	{key: 'FR', label: 'Freshman/1st year'},
	{key: 'SOPH', label: 'Sophomore/2nd year'},
	{key: 'JR', label: 'Junior/3rd year'},
	{key: 'SR', label: 'Senior/4th year'},
	{key: 'PG', label: 'Post-Graduate'},
	{key: 'GAP', label: 'Pre-College Gap'}
];

class BasicInformation extends React.Component {
	state = {
		SRI_GRADE_LVL: null,
		SRI_HONORS: null
	}
	getStatusesFromProps = (props) => {
		const statuses = props.statuses || {};
		this.setState({
			SRI_GRADE_LVL: statuses.SRI_GRADE_LVL,
			SRI_HONORS: statuses.SRI_HONORS
		});
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateStatuses(this.props.form)
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	componentDidMount() { this.getStatusesFromProps(this.props); }
	componentWillReceiveProps(nextProps) { this.getStatusesFromProps(nextProps); }
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'academic/basic');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'academic/basic');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit}>
				<Form.Item label="School Name" {...formItemLayout}>
					{getFieldDecorator('schoolName', {
						initialValue: (this.props.agencyLoaded && this.props.agency.Name)? this.props.agency.Name: ''
					})(
						<Input disabled />
					)}
				</Form.Item>
				<Form.Item label="Grade Level for Voyage" {...formItemLayout}>
					{getFieldDecorator('SRI_GRADE_LVL', {
						initialValue: this.state.SRI_GRADE_LVL,
						rules: [{required: true, message: 'Please select your grade level'}]
					})(
						<Select disabled={disabled}>
							{gradeLevels.map(grade => {
								return <Select.Option key={grade.key}>{grade.label}</Select.Option>
							})}
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Enrolled in Honors Program" {...formItemLayout}>
					{getFieldDecorator('SRI_HONORS', {
						initialValue: this.state.SRI_HONORS,
						rules: [{required: true, message: 'Please indicate if you are enrolled in an honors program'}]
					})(
						<Radio.Group disabled={disabled}>
							<Radio value="E">Yes</Radio>
							<Radio value="N">No</Radio>
						</Radio.Group>
					)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(BasicInformation));



// WEBPACK FOOTER //
// ./portal-components/Portal/Academic/BasicInformation.jsx